import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component type={"SiteHeader"} title={{"className":""}} button={{"className":"btn-box"}} item={{"className":""}} />
)
}